export default __webpack_public_path__ + "static/astrorei-come-migliorare-lavoro-da-remoto-consigli-per-developers-5a635f462a44679641a179f3ab1064f7.jpg";